import { getEventTarget } from './utils'
import { sortCasinos } from './table-sorting'
import { loadMoreCasinos } from './table-load-more'
import { filterListing, removeFilters, searchFilters, toggleFilters } from './table-filters'

document.addEventListener('click', async (e) => {
  // expand filters button
  if (e.target.classList.contains('expand-filters') || e.target.closest('.expand-filters')) {
    const button = getEventTarget(e.target, 'expand-filters')
    toggleFilters(button)
  }

  // remove filters button
  if (e.target.classList.contains('remove-filters') || e.target.closest('.remove-filters')) {
    const button = getEventTarget(e.target, 'remove-filters')
    removeFilters(button)
  }

  // filter fields
  if (e.target.tagName.toLowerCase() === 'input' && e.target.closest('label[data-value]')) {
    await filterListing(e.target)
  }

  // load more casinos
  if (e.target.dataset.limitId) {
    loadMoreCasinos(e.target)
  }

  // sort casinos
  if (
    e.target.classList.contains('spinoko-listing--sort-button') ||
    e.target.closest('.spinoko-listing--sort-button')
  ) {
    const button = getEventTarget(e.target, 'spinoko-listing--sort-button')
    sortCasinos(button)
  }
})

document.addEventListener('input', (e) => {
  // search filters
  if (e.target.tagName.toLowerCase() === 'input' && e.target.dataset.filterSearch) {
    searchFilters(e.target)
  }
})
